<template>
  <div>
       
<!--    <div class="lines-history global-page linear-gradient">
        <div v-for="index in 5"
          :key="index"
          class="infoPage">
        </div>
    </div> -->
    <div id="background-home"></div>

    <v-container class="second-content">



       <v-row no-gutters>

        <v-col lg="6" md="6" sm="12" cols="12" class="pa-5 mb-5 quadre-padding">

          <!--         
            <img v-if="image==='film-manual.jpg'" style="float:left; margin-left:-150px; margin-right:50px; margin-top:-10px" class="image-producte"  :src="require('../../../src/assets/images/productes/'+`film-manual-packetgrup.jpg`)" alt="film manual Packet Grup"> -->
                  <!--  <p>
              {{ text }}
            </p> 
          -->

          <div class="quadre-producte" :style="styleObject">

            <openbox class="iconcom" />

            <h2 class="pb-2 mb-5" :color="menu[0].color">
              {{ name }}
            </h2>
  
            <p v-html="text"> </p>

          </div>
        </v-col>
        <v-col lg="6" md="6" sm="12" cols="12" class="pa-5">

            <v-carousel
              cycle
              height="400"
              hide-delimiter-background
              show-arrows-on-hover
            >
              <v-carousel-item
                v-for="(img, i) in image"
                :key="i"
              >
                <v-sheet
                  height="100%"
                >
                  <v-row
                    class="fill-height"
                    align="center"
                    justify="center"
                  >
                    <div class="display-3">
                      <img class="image-producte" :src="require('../../../src/assets/images/products/'+`${img.src}`)" :alt="img.src" :title="img.src">
                    </div>
                  </v-row>
                </v-sheet>
              </v-carousel-item>
            </v-carousel>

        </v-col>
        </v-row>

        <v-row class="no-gutters">
          <div class="filters">
            <submenu-consumibles />
          </div>
        </v-row>

        <v-row>
          <v-col>

            <div class="quadre-final">
              
              <div class="baseicon">
                <v-icon class="producte-icon"
                  data-aos="fade-right"
                  data-aos-duration="2000"
                  data-aos-delay="200">
                  mdi-truck-check-outline  
                </v-icon>
              </div>

              {{ $t('fraseFinalConsumibles') }}
              
          {{ name }}

            </div>

          </v-col>
          <!-- 
            <h3>
              Descripció tècnica
            </h3>
            <descripcio-tecnica />
          -->
       </v-row>

      <div class="finalPage"> </div>
    </v-container>

  </div>
</template>

<script>

// import DescripcioTecnica from '@/components/elements/DescripcioTecnica.vue'
import Openbox from '@/assets/svg/Openbox.vue'
import SubmenuConsumibles from '@/components/menu/submenu/SubmenuConsumibles.vue'

export default {
  name: 'ConsumiblesChild',
  metaInfo() {
    return { 
      metaInfo: {
        title: this.name + this.$t('consumiblesMetaTitle'),
      },
      title: this.name + " - Packet Grup - " + this.$t('consumiblesMetaTitle'),
      description: this.$t('consumiblesMetaTitle'),
    }
  },
  components: {
    // DescripcioTecnica,
    Openbox,
    SubmenuConsumibles
  },
  props: [
    'name',
    'image',
    'text'
  ],
  computed: {
    menu () {
      return this.$store.state.menu
    },
    styleObject() {
      return {
        "border-color": '#7b0909',
      }
    }
  }
}

</script>

<style scope lang="scss">

h2 {
  border-color: #f1a44d;
  width: 100%;
}

h3 {
  font-family: 'Cabin', sans-serif;
  color: #000;
  font-weight: normal;
  border-bottom: 2px solid #2f2f2f;
  margin: 15px 15px 0;
}

.iconcom {
  float: left;
  justify-content: left;
  display: flex;
  align-items: flex-start;
  margin: -30px 0 15px 0;
  background: #fff;
  box-sizing: content-box;
  width: 80px;
}

.producte-icon {
  color: #fdc474 !important;
  margin-top: -80px;
  border: 5px solid #fdc474;
}

.theme--light.v-icon {
  color: rgb(160, 55, 55);
  color: white;
}

.v-application .filters .pl-5 {
  
    padding: 0 !important;
}
</style>
